import type { ItemType } from "@shared/graphql.types";

export const calculateBasketCount = (basket: ItemType[]): number => {
  if (!basket) return 0;

  return basket.reduce((count, item) => {
    return item?.variant?.availability?.status === "instock" ||
      item?.variant === null
      ? count + item.quantity
      : count;
  }, 0);
};
